import {
  IconBookmark,
  IconDashboard,
  IconPerson,
  IconSettings,
  IconChat,
} from "../../../styles/icons";

export const userMenu = [
  {
    key: "umShort01",
    label: "Dashboard",
    href: "/accounts/user-account/dashboard",
    leftIcon: <IconDashboard />,
  },
  {
    key: "userChatMenu",
    label: "Chat",
    href: "/accounts/user-account/dashboard/messages",
    leftIcon: <IconChat />,
  },
  {
    key: "umShort02",
    label: "Account settings",
    href: "/accounts/common-account/account-settings",
    leftIcon: <IconSettings />,
  },
  {
    key: "umShort03",
    label: "Bookmarks",
    href: "/accounts/common-account/bookmarks",
    leftIcon: <IconBookmark />,
  },
  {
    key: "umShort04",
    divider: true,
    label: "Help centre",
    href: "/help-centre",
    size: "small",
  },
  {
    key: "umShort05",

    label: "Contact us",
    href: "mailto:info@welldoing.org",
    size: "small",
  },
];

export const userMenuLong = [
  ...userMenu,
  {
    key: "umLong01",
    divider: true,
    label: "Log out",
    button: true,
    onClick: "handleLogout()",
    size: "small",
  },
];

export const practitionerMenu = [
  {
    key: "pmshort01",
    label: "Dashboard",
    href: "/accounts/practitioner-account/dashboard",
    leftIcon: <IconDashboard />,
  },
  {
    key: "therapistChatMenu",
    label: "Chat",
    href: "/accounts/practitioner-account/dashboard/messages",
    leftIcon: <IconChat />,
  },
  {
    key: "pmshort02",
    label: "Profile settings",
    href: "/accounts/practitioner-account/profile-settings",
    leftIcon: <IconPerson />,
  },
  {
    key: "pmshort03",
    label: "Account settings",
    href: "/accounts/common-account/account-settings",
    leftIcon: <IconSettings />,
  },
  {
    key: "pmshort04",
    label: "Bookmarks",
    href: "/accounts/common-account/bookmarks",
    leftIcon: <IconBookmark />,
  },
];

export const practitionerMenuMobile = [
  ...practitionerMenu,
  {
    key: "pmLong01",
    divider: true,
    label: "Help centre",
    href: "/help-centre",
    size: "small",
  },
  {
    key: "pmLong02",
    label: "Contact us",
    href: "mailto:info@welldoing.org",
    size: "small",
  },
];

export const practitionerMenuLong = [
  ...practitionerMenu,
  {
    key: "pmLong01",
    divider: true,
    label: "Help centre",
    href: "/help-centre",
    size: "small",
  },
  {
    key: "pmLong02",
    label: "Contact us",
    href: "mailto:info@welldoing.org",
    size: "small",
  },
  {
    key: "pmLong03",
    divider: true,
    label: "Log out",
    button: true,
    onClick: "handleLogout()",
    size: "small",
  },
];

export const visitorMenu = [
  {
    key: "vm1",
    label: "Find a therapist",
    href: "/counselling",
  },
  {
    key: "vm2",
    label: "MatchPlus",
    href: "/personalised-matching-service",
  },
  {
    key: "recommended",
    label: "Recommended books",
    href: "/recommended-books",
  },
  {
    key: "vm3",
    label: "Read",
    submenu: [
      {
        key: "3sm1",
        label: "All articles",
        href: "/article",
      },
      {
        key: "3sm2",
        label: "What's worrying you?",
        href: "/whats-worrying-you",
      },
      {
        key: "3sm3",
        label: "Types of therapy",
        href: "/types-of-therapy",
      },
      {
        key: "3sm9",
        label: "Press",
        href: "/press",
      },
    ],
  },
];

export const practitionerAdminMenu = [
  {
    key: "um2",
    label: "Account settings",
    href: "/accounts/common-account/account-settings",
    leftIcon: <IconSettings />,
  },
];
